import { MaxAircraftParams } from '@pelicargo/types';
import { AircraftType, DocumentType, FreightService } from '@prisma/client';

// All max params are in cm and kg
export const MAX_WIDE_BODY_PARAMS: MaxAircraftParams = {
  length: 396.24,
  width: 243.84,
  height: 162.56,
  weight_per_piece: 10000,
};
export const MAX_FREIGHTER_PARAMS: MaxAircraftParams = {
  length: 7000,
  width: 381,
  height: 304,
  weight_per_piece: 250000,
};
export const MAX_NARROW_BODY_PARAMS: MaxAircraftParams = {
  length: 121.92,
  width: 101.6,
  height: 78.74,
  weight_per_piece: 150,
};
export const MAX_RFS_PARAMS: MaxAircraftParams = {
  length: Number.MAX_SAFE_INTEGER,
  width: Number.MAX_SAFE_INTEGER,
  height: Number.MAX_SAFE_INTEGER,
  weight_per_piece: Number.MAX_SAFE_INTEGER,
};

export const MAX_PARAMS = {
  [AircraftType.Freighter]: MAX_FREIGHTER_PARAMS,
  [AircraftType.WideBody]: MAX_WIDE_BODY_PARAMS,
  [AircraftType.NarrowBody]: MAX_NARROW_BODY_PARAMS,
  [AircraftType.RFS]: MAX_RFS_PARAMS,
};

export const NARROW_BODY_THRESHOLDS = {
  length: 35,
  width: 35,
  height: 30,
  weight: 150,
};

export const WIDE_BODY_THRESHOLDS = {
  length: 125,
  width: 96,
  height: 64,
  weight: Infinity, // there is no weight restriction for wide-bodies rn
};

export const DOCUMENT_TYPES_REQUIRING_APPROVAL: DocumentType[] = [DocumentType.AIRWAY_BILL];

export const INLAND_FREIGHT_SERVICES: FreightService[] = [FreightService.EXW, FreightService.FCA];

export const FREIGHT_SERVICES_REQUIRING_RATES: FreightService[] = [FreightService.AFR, FreightService.EXW];

/**
 * Service-level connection dependencies for quote variant linkage.
 * Key: service that should receive connections.
 * Value: prerequisite services that can provide those connections.
 */
export const FREIGHT_SERVICE_CONNECTION_DEPENDENCIES: Partial<Record<FreightService, FreightService[]>> = {
  [FreightService.AFR]: [FreightService.EXW, FreightService.FCA],
};